module.exports = __webpack_public_path__ + "static/img/qiangzhuangpaijiu.fa8563d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/gameImg/qiangzhuangpaijiu.jpg
// module id = GGvJ
// module chunks = 0